(function () {
  function initBhetwaleDiwaliHero() {
    var roots = document.querySelectorAll('[data-bw-diwali-hero]');
    roots.forEach(function (root) {
      if (root.dataset.bwDiwaliReady === 'true') return;
      var slides = Array.prototype.slice.call(root.querySelectorAll('.bw-v2__diwali-slide'));
      if (slides.length < 2) return;
      root.dataset.bwDiwaliReady = 'true';
      var current = -1;

      slides.forEach(function (img) {
        img.style.display = 'none';
        img.style.opacity = '0';
        img.style.transition = 'opacity .5s ease';
      });

      function showNext() {
        var next;
        do {
          next = Math.floor(Math.random() * slides.length);
        } while (next === current && slides.length > 1);

        if (current >= 0) {
          slides[current].style.opacity = '0';
          slides[current].style.display = 'none';
        }

        slides[next].style.display = 'block';
        requestAnimationFrame(function () {
          slides[next].style.opacity = '1';
        });
        current = next;
      }

      showNext();
      window.setInterval(showNext, 12000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBhetwaleDiwaliHero);
  } else {
    initBhetwaleDiwaliHero();
  }

  document.addEventListener('shopify:section:load', initBhetwaleDiwaliHero);
})();